import type { FaireProductEntity } from "../../entity_types/product";

export const p_pagsu9gxzg: FaireProductEntity = {
  token: "p_pagsu9gxzg",
  type: "product",
  name: "bunny watercolor wall art print",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/6f72545f9c20befd3e61e29340fb0464ae134f2a7f1c411da3ea98bcfc95fac9.jpeg",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    'Display this adorable bunny print in a child\'s room or anywhere you like in your home.\n\nDetails: \n- 8"x10" print of original watercolor artwork by Emily Lex\n- Printed in full color on thick, superfine paper\n- Packaged in a clear protective sleeve with chipboard backing\n- Frame and mat not included\n',
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:09.465Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
